<div class="modal-header">
  <h4 class="modal-title fw-normal">Upload File(s)</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  @if (uploading()) {
  <groundworks-state-message type="loading" message="Uploading file(s)..." class="d-flex" />
  } @else {
  <form [formGroup]="uploadForm" class="d-flex flex-column gap-3">
    <div>
      <label class="form-label" for="sectionIdSelect">Section <span class="text-danger">*</span></label>
      <select id="sectionIdSelect" class="form-select" formControlName="sectionId"
        [class.is-invalid]="uploadForm.controls.sectionId.touched && uploadForm.controls.sectionId.invalid">
        <option [ngValue]="null" disabled>Please select</option>
        @for (section of sections(); track section.id) {
        <option [ngValue]="section.id">{{ section.name }}</option>
        }
      </select>
      @if (uploadForm.controls.sectionId.touched && uploadForm.controls.sectionId.invalid) {
      <div class="invalid-feedback d-block">Section is required.</div>
      }
      @if (loadSectionsError()) {
      <div class="text-danger small mt-1">{{ loadSectionsError() }}</div>
      }
    </div>

    <div>
      <label class="form-label" for="groupIdSelect">Attachment Group</label>
      <select id="groupIdSelect" class="form-select" formControlName="groupId">
        <option [ngValue]="null">Please select</option>
        @for (group of sectionGroups(); track group.id) {
        <option [ngValue]="group.id">{{ group.groupName }}</option>
        }
      </select>
      @if (loadGroupsError()) {
      <div class="text-danger small mt-1">{{ loadGroupsError() }}</div>
      }
    </div>

    <div>
      <label class="form-label" for="descriptionInput">Add description to all file(s)</label>
      <input id="descriptionInput" type="text" class="form-control" placeholder="Please select"
        formControlName="description" />
    </div>
  </form>
  }
</div>

<div class="modal-footer">
  <button class="btn btn-primary" type="button" (click)="onUpload()"
    [disabled]="uploading() || uploadForm.invalid">
    Upload
  </button>
</div>
